<template>
  <router-view></router-view>
</template>

<script>
import Vue from 'vue'
import vueCountryRegionSelect from 'vue-country-region-select'
Vue.use(vueCountryRegionSelect)
export default {
  methods: {
    initializeLayout() {
      if (!this.$rtl.isRTL) {
        // Just make sure rtl css is off when we are not on rtl
        this.$rtl.disableRTL();
      }
    }
  },
  mounted() {
    this.initializeLayout();
  }
};
</script>
<style >


:root {
  --background-color-primary: #f5f5f5;
  --background-color-secondary: #ffffff;
  --card-border-color: #ffffff;
  --primary-color: #374151;
  --accent-color: #212529;
  --primary-input-text-color: #212529;
  --dark: #212529;
  --text-primary-color: #101111;
  --element-size: 64px;
  --input-border-color: #101111;
  --btn-primary-color: #101111;
  --btn-primary-hover-color: #263148;  
  --em-primary: #374151;
  
}


/* :root.dark-theme {
  
  --background-color-primary: #2D3250;
  --background-color-secondary: #424769;
  --primary-color: #F6B17A;
  --accent-color: #c3c3c3;
  --primary-input-text-color: #e9e9e9;
  --gray-900: #e9e9e9;
  --dark: #d4d5d6;
  --text-primary-color: #ddd;
  --input-border-color: #ffffff;
  --bs-primary: #7267ef;
  --bs-secondary: #6c757d;
} */
:root.dark-theme {
  /* --background-color-primary: #1e1e1e; */
  --background-color-primary: #131920;
  --background-color-secondary: #1b232d;
  --card-border-color: #263240;
  --primary-color: #F6B17A;
  --accent-color: #c3c3c3;
  --primary-input-text-color: #e9e9e9;
  --gray-900: #e9e9e9;
  --dark: #d4d5d6;
  --text-primary-color: #ddd;
  --input-border-color: #ffffff;
  --em-primary: #686868;
  --btn-primary-color: #686868;
  --btn-primary-hover-color: #5b5b65;
  --bs-secondary: #6c757d;
}
</style>